export const AMBIENT_LIGHT = 1
export const AMBIENT_DARK = 2

export const ROLE_ADMIN    = 1
export const ROLE_MANAGER  = 2
export const ROLE_EMPLOYEE = 3
export const ROLE_STAFF    = 4
export const ROLE_CASHIER  = 5

export const PRODUCT_TYPE_SIMPLE       = 1;
export const PRODUCT_TYPE_CONFIGURABLE = 2;